._1k2466l0 {
  position: relative;
  width: 100%;
  height: auto;
}
._1k2466l1 {
  font-weight: 500;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  color: var(--_1qu8za25);
}